'use strict';
namespace TR {

    export interface IPriorityBoardingInfo {
        isSelected: boolean;
        outboundOnly: boolean;
        inboundOnly: boolean;
        both: boolean;
        oneWayFlightPB: boolean;
        optionDetails?: any;
    }

    export class PriorityBoardingService {

        constructor() {
        }

        getPriorityBoardingInfo(flight, flightOptions): IPriorityBoardingInfo {
            const oneWayFlight: boolean = flight.Details.Itinerary.Legs.length === 1;
            const bothWaysFlight: boolean = flight.Details.Itinerary.Legs.length === 2;
            const extras: any[] = flight.Details.FlightSectorOptionalExtras;

            const pbInfo: IPriorityBoardingInfo = {
                isSelected: false,
                outboundOnly: false,
                inboundOnly: false,
                both: false,
                oneWayFlightPB: false
            };

            if (oneWayFlight) {
                pbInfo.optionDetails = this._getPBOption(extras[0]);
                pbInfo.oneWayFlightPB = Boolean(pbInfo.optionDetails);
            }

            if (bothWaysFlight) {
                pbInfo.outboundOnly = extras.length === 2 && Boolean(this._getPBOption(extras[0]));
                pbInfo.inboundOnly = extras.length === 2 && Boolean(this._getPBOption(extras[1]));
                pbInfo.both = extras.length === 1 && Boolean(this._getPBOption(extras[0]));

                if (pbInfo.outboundOnly || pbInfo.inboundOnly || pbInfo.both) {
                    pbInfo.optionDetails = this._getPBOption(extras[0]) || this._getPBOption(extras[1]);
                }
            }

            if (pbInfo.optionDetails && pbInfo.optionDetails.OptionId) {
                pbInfo.isSelected = Boolean(_.find(flightOptions, ['OptionId', pbInfo.optionDetails.OptionId]));
            }

            return pbInfo;
        };

        private _getPBOption(flightExtra): any {
            if (!flightExtra && !flightExtra.OptionalExtras) { return; }

            const otherOptions: any = _.find(flightExtra.OptionalExtras, ['Type', 2]);

            if (otherOptions && otherOptions.SingleOptionalExtras && otherOptions.SingleOptionalExtras.length) {
                return _.find(otherOptions.SingleOptionalExtras, ['Type', 'PriorityBoarding']);
            }
}
    }

    angular
        .module('TR')
        .service('priorityBoardingService', PriorityBoardingService);
}
